import React, { useEffect, useState } from "react";
import Axios from "axios";
import dayjs from "dayjs";
import { Toast } from "../../common/message";
import { useNavigate } from "react-router-dom";
import { IDCheck, NameCheck, PasswordCheck, EmailCheck } from "../../common/regCheck";

const Register = () => {
  Axios.defaults.withCredentials = true; // 세션을 관리하고자하는 파일에 꼭 작성
  const navigate = useNavigate();

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  const position = ['직책', '사장', '점장', '매니저'];
  const store = ['담당 매장', '탄방점', '둔산점', '자양점', '충대점'];

  const [value, setValue] = useState({});

  useEffect(()=>{
    document.title = '베이프마켓 - 회원가입';
  }, [])

  const valueHandle = (e)=>{
    setValue({ ...value, [e.target.id]: e.target.value });
  };
  
  const register = async (e) => {
    e.preventDefault();
    
    if(!value.userid) return Toast.fire({ icon: "warning", text: '아이디를 입력해 주세요'});
    if(value.userid.length < 6) return Toast.fire({ icon: "warning", text: '아이디는 6글자 이상 입력해 주세요'});
    if(!IDCheck(value.userid)) return Toast.fire({ icon: "warning", text: '아이디는 영문 및 숫자만 입력해 주세요.'});
    if(!value.username) return Toast.fire({ icon: "warning", text: '사용자 이름을 입력해 주세요'});
    if(value.username.length < 2) return Toast.fire({ icon: "warning", text: '사용자 이름은 2글자 이상 입력해 주세요'});
    if(!NameCheck(value.username)) return Toast.fire({ icon: "warning", text: '사용자 이름은 한글 실명으로만 입력해 주세요'});
    if(!value.userpassword) return Toast.fire({ icon: "warning", text: '비밀번호를 입력해 주세요'});
    if(!value.userpasswordcheck) return Toast.fire({ icon: "warning", text: '비밀번호 확인을 입력해 주세요'});
    if(value.userpassword !== value.userpasswordcheck) return Toast.fire({ icon: "warning", text: '비밀번호가 서로 다릅니다'});
    if(!PasswordCheck(value.userpassword)) return Toast.fire({ icon: "warning", text: '비밀번호는 영문, 숫자만 포함 6~20자리를 입력해 주세요'});
    if(!value.useremail) return Toast.fire({ icon: "warning", text: '이메일을 입력해 주세요'});
    if(!EmailCheck(value.useremail)) return Toast.fire({ icon: "warning", text: '이메일 형식을 다시 확인해 주세요'});
    if(!value.userposition) return Toast.fire({ icon: "warning", text: '직책을 선택해 주세요'});
    if(!value.userstore) return Toast.fire({ icon: "warning", text: '이용하실 담당 매장을 선택해 주세요'});

    if(!window.confirm(`${value.username}님, 가입을 진행하시겠습니까?`)) return;

    // Permission 데이터 넣기
    let permission = 0;
    switch(value.userposition){
      case '사장' : permission = 5; break;
      case '점장' : permission = 4; break;
      case '매니저' : permission = 3; break;
      case '수습' : permission = 2; break;
      default : break;
    }
    await Axios.post(`/api/register`, {
      id : value.userid, password: value.userpassword, name: value.username, email: value.useremail,
      position: value.userposition, store: value.userstore, date: toDay.time,
      permission: permission
      })
      .then((res) => {
      if (res.data.Value) {
        Toast.fire({ icon: "success", text: res.data.message });
        return navigate("/login");
      } else {
        return Toast.fire({ icon: "error", text: res.data.message });
      }
    })
    .catch((err)=>{
      Toast.fire({ icon: "error", titleText: '오류가 발생했습니다', text: err });
    });
  };

  return (
    <div className="bg-[#1E1E1E] flex flex-col justify-center p-3 items-center h-screen text-sm">
      <div className="gap-3 shadow-inner duration-150 shadow-[#3E3E3E]/80 bg-[#2E2E2E] border-[1px] border-[#3E3E3E]/80 rounded-md p-3 w-full md:w-[450px] md:h-[600px]">
        <div className="flex flex-col gap-3 justify-center items-center h-full">
        {/* <img className="w-32 md:hidden inline" src="./vapemarket_logo.png" alt="logo" /> */}
          <div className='lg:relative lg:min-w-[305px] p-3 text-2xl md:text-3xl text-yellow-400 mx-5' style={{ fontFamily: 'Nosifer, cursive'}}>
            <p className='mb-5'>
              VapeMarket
            </p>
          </div>
          <form className="flex flex-col gap-3 p-3 w-full" autoComplete="off">
            <input className="p-3 rounded-lg hover:rounded-sm hover:bg-[#3E3E3E]/80 focus:rounded-sm w-full bg-[#1E1E1E]/50 focus:bg-[#1E1E1E] outline-none border-[1px] border-[#3E3E3E] transition focus:border-transparent" id="userid" type="text" onChange={ valueHandle } placeholder="User ID" />
            <input className="p-3 rounded-lg hover:rounded-sm hover:bg-[#3E3E3E]/80 focus:rounded-sm w-full bg-[#1E1E1E]/50 focus:bg-[#1E1E1E] outline-none border-[1px] border-[#3E3E3E] transition focus:border-transparent" id="username" type="text" onChange={ valueHandle } placeholder="User Name" />
            <input className="p-3 rounded-lg hover:rounded-sm hover:bg-[#3E3E3E]/80 focus:rounded-sm w-full bg-[#1E1E1E]/50 focus:bg-[#1E1E1E] outline-none border-[1px] border-[#3E3E3E] transition focus:border-transparent" id="userpassword" type="password" onChange={ valueHandle } placeholder="User Password" />
            <input className="p-3 rounded-lg hover:rounded-sm hover:bg-[#3E3E3E]/80 focus:rounded-sm w-full bg-[#1E1E1E]/50 focus:bg-[#1E1E1E] outline-none border-[1px] border-[#3E3E3E] transition focus:border-transparent" id="userpasswordcheck" type="password" onChange={ valueHandle } placeholder="User Password Check" />
            <input className="p-3 rounded-lg hover:rounded-sm hover:bg-[#3E3E3E]/80 focus:rounded-sm w-full bg-[#1E1E1E]/50 focus:bg-[#1E1E1E] outline-none border-[1px] border-[#3E3E3E] transition focus:border-transparent" id="useremail" type="email" onChange={ valueHandle } placeholder="User Email" />
            <div className="flex gap-3 w-full">
              <select id="userposition" className='bg-[#1E1E1E]/50 p-3 focus:rounded-sm duration-150 hover:scale-[0.99] focus:bg-[#1E1E1E] my-2 md:my-0 px-2 w-full rounded-md cursor-pointer text-sm outline-none border-[1px] border-gray-500' onChange={ valueHandle }>
                {position.map((position) => (
                  <option value={position} key={position}>
                    {position}
                  </option>
                ))}
              </select>
              <select id="userstore" className='bg-[#1E1E1E]/50 p-3 focus:rounded-sm duration-150 hover:scale-[0.99] focus:bg-[#1E1E1E] my-2 md:my-0 px-2 w-full rounded-md cursor-pointer text-sm outline-none border-[1px] border-gray-500' onChange={ valueHandle }>
                {store.map((store) => (
                  <option value={store} key={store}>
                    {store}
                  </option>
                ))}
              </select>
            </div>
            <button className="p-3 rounded-md w-full transition duration-150 hover:bg-[#1E1E1E]/80 active:bg-[#1E1E1E]/60 bg-[#1E1E1E] outline-none" type="submit" onClick={register}>
              Register
            </button>
            <button className="p-3 rounded-md w-full transition duration-150 hover:bg-[#1E1E1E]/80 active:bg-[#1E1E1E]/60 bg-[#1E1E1E] outline-none" onClick={(e) => {
              e.preventDefault();
              navigate("/login");
              }}>
              LogIn Page
          </button>
          </form>        
        </div>
      </div>
    </div>
  );
};
export default Register;
